import { render, staticRenderFns } from "./SemesterBars.vue?vue&type=template&id=20715bb0&"
import script from "./SemesterBars.vue?vue&type=script&lang=ts&"
export * from "./SemesterBars.vue?vue&type=script&lang=ts&"
import style0 from "./SemesterBars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports